import { FormattedMessage } from 'react-intl';

import StageImage from '@components/StageImage';
import styles from '@components/StageInfo.module.css';
import { StageEnum } from '@typing/Generated';

type Props = {
  stage: StageEnum | null;
};

const StageInfo = ({ stage }: Props) => {
  if (stage) {
    return (
      <>
        <div className={styles.stage}>
          <div>
            <StageImage className={styles.img} stage={stage} />
          </div>
          <div>
            <div className={styles.title}>
              <FormattedMessage id={`models.journey.stage.${stage}`} />
            </div>
            <div>
              <FormattedMessage id={`pages.navigatingCarePlan.${stage}.p1`} />
            </div>
          </div>
        </div>
      </>
    );
  }
  return null;
};

export default StageInfo;
